import { useState } from "react";
import { useAuthStore } from "../../stores/useAuthStore";
import "./index.css";
import { LoginComp } from "../../components/common/LoginComp";
import { WatchListComp } from "./WatchListComp";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const WatchListScreen = () => {
  const { profile } = useAuthStore();
  const isLoggedIn = Object.keys(profile).length > 0;
  const [searchQuery, setSearchQuery] = useState("");

  const getSearchView = () => {
    return (
      <div className="sticky-search-container">
        <div
          style={{
            width: "90%",
            maxWidth: "600px",
            position: "relative",
          }}
        >
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder="Search in watchlist"
              className="search-input-field"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            />
            {searchQuery && (
              <ClearIcon
                className="clear-icon-btn"
                onClick={() => setSearchQuery("")}
              />
            )}
            <SearchIcon
              className="search-icon-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="screen-container">
      {isLoggedIn ? (
        <>
          {getSearchView()}
          <WatchListComp searchQuery={searchQuery} />
        </>
      ) : (
        <LoginComp />
      )}
    </div>
  );
};

export default WatchListScreen;
